import styled, { css, keyframes } from 'styled-components';

export const animationClassNames = 'route-fade-in-out';
export const ANIMATION_DURATION_IN_MS = 300;

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translate3d(0, 50px, 0);
    }

    to {
        opacity: 1;
        transform: translate3d(0, 0, 0);
    }
`;

const fadeOut = keyframes`
    from {
        opacity: 1;
        transform: translate3d(0, 0, 0);
    }

    to {
        opacity: 0;
        transform: translate3d(0, 50px, 0);
    }
`;

const FadeInAnimation = css`
    animation-name: ${fadeIn};
    animation-duration: ${ANIMATION_DURATION_IN_MS}ms;
    animation-timing-function: ease-out;
`;

const FadeOutAnimation = css`
    animation-name: ${fadeOut};
    animation-duration: ${ANIMATION_DURATION_IN_MS}ms;
    animation-timing-function: ease-in;
`;

export const RouteContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    height: inherit;
`;

export const RouteContent = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    height: inherit;

    &.${animationClassNames}-enter {
        opacity: 1;
        transform: translate3d(0, 0, 0);
    }

    &.${animationClassNames}-enter-active {
        ${FadeInAnimation}
    }

    &.${animationClassNames}-exit {
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        position: absolute;
        opacity: 0;
        transform: translate3d(0, 50px, 0);
    }

    &.${animationClassNames}-exit-active {
        ${FadeOutAnimation}
    }
`;
